module.exports = {"id":"202078","name":"Darlington Nagbe","rating":"74","photo":"./data/images/photos/0/202078.png","club":{"name":"Atlanta United FC","logo":"./data/images/clubs/AtlantaUnitedFC.png"},"positions":["MG","MD","MDC","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DarlingtonNagbe0.json
// module id = 979
// module chunks = 0